import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=7445ae44&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7445ae44"]])

export default __exports__